import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UserStore } from 'app/core/services/user.store';

@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (userStore.impersonationData()) {
      <div
        data-cy="impersonation-banner"
        class="bg-gradient-to-r from-warning-100 via-warning-50 to-warning-100 text-warning-800 border-b border-warning-300 shadow-sm z-40">
        <div class="w-full mx-auto flex items-center justify-between py-3 px-6">
          <div class="flex items-center">
            <div>
              <div class="text-warning-900 font-medium" data-cy="impersonation-message">
                Je werkt als <span class="font-bold">{{ impersonatedUserName() }}</span>
              </div>
            </div>
          </div>
          <button
            mat-flat-button
            color="warn"
            data-cy="stop-impersonating-button"
            class="ml-4 shadow-sm hover:shadow-md transition-shadow duration-200"
            (click)="userStore.stopImpersonating()">
            <mat-icon class="mr-1" svgIcon="heroicons_solid:arrow-left"></mat-icon>
            &nbsp; Beëindig overname
          </button>
        </div>
      </div>
    }
  `,
})
export class ImpersonationBannerComponent {
  readonly userStore = inject(UserStore);

  readonly impersonatedUserName = computed(() => {
    const user = this.userStore.users()?.[0];
    return user?.name?.trim() || user?.emailAddress?.trim() || 'geselecteerde gebruiker';
  });
}
